import { SchoolProgramType, isSchoolProgramType } from './program-type.model';

export type ActivitySchoolProperties = {
  program_type: SchoolProgramType;
};

export const defaultSchoolProperties: ActivitySchoolProperties = {
  program_type: SchoolProgramType.PrimarySchool,
};

export const resolveSchoolProgramType = (value: unknown): SchoolProgramType =>
  isSchoolProgramType(value) ? value : SchoolProgramType.PrimarySchool;
